var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "#E4F5FF",
    stroke: "#2177FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 8.4375L16.8002 14.7032C16.7012 16.304 16.6517 17.1045 16.2505 17.6799C16.0521 17.9644 15.7967 18.2046 15.5004 18.385C14.9013 18.75 14.0994 18.75 12.4955 18.75C10.8894 18.75 10.0864 18.75 9.48691 18.3843C9.1905 18.2035 8.935 17.963 8.73668 17.678C8.33555 17.1016 8.28716 16.3001 8.19038 14.697L7.8125 8.4375",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 8.4375H18.125M15.0348 8.4375L14.6082 7.55733C14.3247 6.97266 14.183 6.68033 13.9386 6.498C13.8843 6.45756 13.8269 6.42159 13.7669 6.39044C13.4962 6.25 13.1713 6.25 12.5216 6.25C11.8555 6.25 11.5225 6.25 11.2473 6.39632C11.1863 6.42875 11.1281 6.46618 11.0733 6.50823C10.826 6.69794 10.6879 7.00097 10.4116 7.60704L10.0331 8.4375",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 15.3125L10.9375 11.5625",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 15.3125L14.0625 11.5625",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNote);
export default __webpack_public_path__ + "static/media/DeleteNote.391e0632849390e2cdb823c1132500dd.svg";
export { ForwardRef as ReactComponent };